import { shallowRef } from "vue";

import {
  ApprovalIcon,
  CheckIcon,
  InfiniteIcon,
} from "@/components/shared/icons";

export const approvalStatus = {
  APPROVE: "Needs Approval",
  COMPLETED: "Completed",
  ALL: "All",
};

export const getApprovalStatusIcon = (status) => {
  switch (status) {
    case approvalStatus.APPROVE:
      return shallowRef(ApprovalIcon);
    case approvalStatus.COMPLETED:
      return shallowRef(CheckIcon);
    case approvalStatus.ALL:
      return shallowRef(InfiniteIcon);
    default:
      return undefined;
  }
};
